import { useMutation } from '@apollo/client'
import React from 'react'

import useMsgs from '@/gf/hooks/useMsgs'
import { SET_GEARFLOW_SHIPPING } from '@/gf/mutations/shipping'

import Button from '@/gf/components/ButtonOld'
import Card from '@/gf/components/Card'
import Checkbox from '@/gf/components/Checkbox'
import ShippingGroupsSettings from '@/gf/components/ShippingGroupsSettings'

import { Store } from '../../../types'

const Shipping = ({ activeStore }: { activeStore: Store }) => {
  const [_msgs, msgsMgr] = useMsgs()
  const [gearflowShipping, setGearflowShipping] = React.useState(activeStore.gearflowShipping)
  const [setGearflowShippingMutation] = useMutation(SET_GEARFLOW_SHIPPING, {
    refetchQueries: ['FetchSession'],
  })

  const onStoreGearflowShippingSubmit = async () => {
    const response = await setGearflowShippingMutation({
      variables: { storeId: activeStore.id, gearflowShipping },
    })
    if (response.errors) {
      msgsMgr.add('Whoops, something went wrong. Please contact support.', 'negative')
    } else {
      msgsMgr.add('Store shipping updated!', 'positive')
    }
  }

  return (
    <>
      <ShippingGroupsSettings store={activeStore} />
      {/* Can't use Gearflow shipping if the store ships free */}
      {!activeStore.shipsFree && activeStore.gearflowPaymentsEnabled && (
        <Card title="Gearflow Shipping">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              onStoreGearflowShippingSubmit()
            }}
          >
            <Card.Section>
              <Checkbox
                label="Gearflow shipping default"
                checked={gearflowShipping}
                onChange={(e) => setGearflowShipping(e.target.checked)}
                value="Use Gearflow shipping"
              />
              <div className="text-sm text-gray-500 space-y-2 mt-2">
                <p>
                  By checking this option, all new orders will have Gearflow shipping enabled by
                  default.
                </p>
                <p>
                  Gearflow shipping enables suppliers to ship on Gearflow&apos;s account, meaning
                  all you have to do is print the label and Gearflow does the rest.
                </p>
                <p>At the moment, Gearflow shipping only supports UPS ground shipping.</p>
              </div>
            </Card.Section>
            <div className="bg-gray-50 p-6 flex justify-end rounded-b-md">
              <Button type="submit" title="Save" />
            </div>
          </form>
        </Card>
      )}
    </>
  )
}

export default Shipping
